import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@sb/ui/button';

import { FirstTouchModuleConfig } from './first-touch.model';

@Component({
  selector: 'first-touch-card',
  templateUrl: './first-touch-card.component.html',
  imports: [ButtonComponent, TranslatePipe],
})
export class FirstTouchCardComponent {
  config = input.required<FirstTouchModuleConfig>();
  buttonState = input<'default' | 'disabled'>('default');
  buttonClick = output<void>();
}
